import TrainingAttachment from 'actions/training/attachment';

export default TrainingAttachment.createReducer();